import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-screen flex flex-col items-center justify-center px-5 text-center">
      <p className="font-heading text-orange text-[8rem] sm:text-[12rem] leading-none">404</p>
      <p className="font-accent text-chick text-3xl -mt-4">This page flew the coop</p>
      <Link to="/" data-testid="notfound-home" className="mt-6 bg-orange text-primary-foreground font-bold uppercase px-8 py-3.5 rounded-md hover:scale-105 transition-transform">
        Back Home
      </Link>
    </div>
  );
}
